import React from 'react';
import PropTypes from 'prop-types';
import { LocaleString } from '@biw/intl';
import LanguageSelector from 'components/shared/language-selector';

const localeShape = PropTypes.shape( {
    code: PropTypes.string
} );

export default class SelectLanguage extends React.Component {
    static propTypes = {
        localeOptions: PropTypes.arrayOf( localeShape ),
        locale: localeShape,
        selectLanguage: PropTypes.func.isRequired,
        busyFetchingLocaleBundle: PropTypes.bool
    }

    static defaultProps = {
        busyFetchingLocaleBundle: false
    }

    handleChangeLocale = locale => this.props.selectLanguage( locale.code );

    render() {
        const { localeOptions, locale, busyFetchingLocaleBundle } = this.props;
        return (
            <div className="select-language">
                <LocaleString TextComponent="h3" code="profile.languageLabel" />
                <LanguageSelector
                    id="language"
                    key="languageSelectorMenu"
                    options={ localeOptions }
                    selectedLocale={ locale }
                    onChange={ this.handleChangeLocale }
                    disabled={ busyFetchingLocaleBundle }
                />
            </div>
        );
    }
}
